import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <span className={`block ${className}`}>{children}</span>;
  return (
    <motion.span
      className="block overflow-hidden pb-[0.08em] -mb-[0.08em]"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-40px" }}
    >
      <motion.span
        className={`block will-change-transform ${className}`}
        variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
        transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};
